import React, { useContext } from 'react'
import { useHistory } from 'react-router-dom'
import SessionContext from './../context/session'
import { faunaAPI } from '../api/fauna-api'
import UserForm from '../components/UserForm'

import {
  CssBaseline,
  Typography,
  Box,
  ThemeProvider,
  createTheme
} from '@material-ui/core';

import logo from '../images/logo.svg'
import { blue, red } from '../components/Colors'

const handleLogin = (event, username, password, history, sessionContext) => {

  event.preventDefault()

  return new Promise((resolve, reject) => {

    faunaAPI
    .login(username, password)
    .then(res => {
      if (res.error ) {
        throw res.error;
      } else if (res === false) {
        res = { error: 'Login failed. Please check your credentials.'};
        throw res;
      } else {
        sessionContext.dispatch({
          type: 'login',
          account: res.account.data,
          sessionLifetime: res.sessionLifetime
        })
        history.push('/')
        resolve(res);
      }
    })
    .catch(e => {
      if (e.error) {
        // noop
      } else {
        alert('Oops, something went wrong')
      }
      reject(e);
    })
  })
}

const composeTheme = outerTheme => {
  const { palette } = outerTheme;
  const composed = { ...outerTheme, palette: { ...palette, background: { default: blue }} };
  return createTheme(composed);
}

const Login = () => {

  const history = useHistory()
  const sessionContext = useContext(SessionContext)

  return (
    <ThemeProvider theme={composeTheme}>
      <CssBaseline />
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        minHeight="100vh"
      >
        <div style={{maxWidth:'500px'}}>
          <div style={{textAlign: 'center'}}>
            <img
              src={logo}
              style={{
                width: '120px',
                objectFit: 'cover',
                height: '50px',
                display: 'inline-block',
                margin: '5px 10px 10px 0px',
                objectPosition: 'top',
                verticalAlign: 'top',
                opacity: '0.9'
              }}
            />
          </div>
          <Typography
            variant="h1"
            color="secondary"
            style={{flexGrow: '1', fontSize: '36px', opacity: '0.9', marginBottom: '40px'}}
            align="center">
            <strong>Purchase Manager</strong>
          </Typography>
          <UserForm
            title="Log in to continue"
            formType="login"
            handleSubmit={(event, username, password) =>
              handleLogin(event, username, password, history, sessionContext)
            }
          ></UserForm>
        </div>
      </Box>
    </ThemeProvider>
  )
}

export default Login;
